<div class="broker-mail-wrapper">
  <div class="broker-mail-content">
    <h1>{{$Locale.get("broker/title")}}</h1>
    <lib-breadcrumbs [steps]="breadcrumbsSteps"></lib-breadcrumbs>
    <div class="panel-wrapper">
      <h3 class="panel-title">{{$Locale.get("broker/summary")}}</h3>
      <div class="panel-content">
        <app-details-panel *ngIf="data && data.details" [items]="detailsItems" [columns]="2" rows="3"></app-details-panel>
        <p *ngIf="data && (data.details | json) == '{}'" class="empty-data-title">
          <mat-icon>error_outline</mat-icon>
          {{$Locale.get("broker/no_details")}}
        </p>
      </div>
    </div>
    <div class="panel-wrapper">
      <h3 class="panel-title">{{$Locale.get("broker/transactions")}}</h3>
      <div class="table-wrapper">
        <app-transactions-table *ngIf="data && data.transactions.length > 0" [data]="data.transactions" (rowClick)="navigateTransaction($event)"></app-transactions-table>
        <p *ngIf="data && !data.transactions.length" class="empty-data-title">
          <mat-icon>error_outline</mat-icon>
          {{$Locale.get("broker/no_transactions")}}
        </p>
      </div>
    </div>
    <div class="panel-wrapper">
      <h3 class="panel-title">{{$Locale.get("broker/errors")}}</h3>
      <div class="table-wrapper">
        <app-errors-table *ngIf="data && data.errors.length > 0" [data]="data && data.errors"></app-errors-table>
        <p *ngIf="data && !data.errors.length" class="empty-data-title  panel-content">
          <mat-icon>error_outline</mat-icon>
          {{$Locale.get("broker/no_errors")}}
        </p>
      </div>
    </div>
  </div>
</div>